const routes = {
  path: "/consentimientos",
  component: () => import("./Module.vue"),
  meta: { requiresAuth: true },
  children : [
    {
      path : '',
      name: "Consentimiento",
      component: () => import("./views/Consentimientos.vue"),
    },
  ]
};

export default routes;
